import type { User } from '@metadevprofile/shared';
import { authApi } from '@metadevprofile/shared/api';
import { getEdenErrorMessage } from '@/common/lib/get-eden-error';
import { notificationService } from '@/common/lib/notification-service';
import { store } from '@/common/redux/store';

export const getCurrentUser = async (): Promise<User | null> => {
  try {
    return await store.dispatch(authApi.endpoints.getCurrentUser.initiate()).unwrap();
  } catch (error) {
    notificationService.error(getEdenErrorMessage(error, 'auth:errors.fetchCurrentUserFailed'));
    return null;
  }
};
